const colorTokens = {
  darkOrange: '#FFB800',
  darkerOrange: '#FF9900',
  orange: '#FFB800',
}

const colors = {
  border: '#dee2e6',
  borderPrimary: '#1D8CF8',
  borderSecondary: '#D2D6DC',
  error: 'red',
  errorTransparent: 'rgba(255, 0, 0, .5)',
  hoverAlternative: '#f0f3f9',
  // hoverAlternative: 'rgba(28, 100, 242, 0.05)',
  main: 'rgba(199, 238, 255, 1)',
  mainHover: 'rgba(29, 138, 248, 0.1)',
  mainTransparent: 'rgba(199, 238, 255, .3)',
  mutedText: '#9FA6B2',
  officeUseBackground: 'rgba(255, 242, 204, 1)',
  officeUseBackgroundHover: '#FFF6EF',
  officeUseBackgroundTransparent: 'rgba(255, 242, 204, .3)',
  officeUseBorder: colorTokens.darkOrange,
  pdfInput: 'rgb(255, 188, 88)',
  pdfInputOfficeUseTransparent: 'rgba(255, 188, 88, .9)',
  pdfInputTransparent: 'rgba(255,245,155, .9)',
  primary: '#1C64F2',
  transparent: 'transparent',
  white: 'white',
}

const spacing = {
  xxsmall: '0.05rem',
  xsmall: '0.25rem',
  small: '0.5rem',
  regular: '1rem',
  large: '1.5rem',
  xlarge: '4rem',
}

const width = {
  border: '1px',
}

const borderRadius = {
  small: '0.25rem',
}

const fontSize = {
  xlarge: '1.25rem',
  default: '1rem',
}

const theme = {
  color: {
    ...colorTokens,
    ...colors,
  },
  spacing,
  width,
  fontSize,
  borderRadius,
}

export default theme
